const FONT_BASE_URL = 'https://every722.s3.amazonaws.com/everyid-assets/fonts/';

let fontsPromise;

export function loadFonts() {
  if (!fontsPromise) {
    fontsPromise = (async () => {
      if (typeof FontFace === 'undefined' || !document.fonts) return [];
      const response = await fetch(`${FONT_BASE_URL}fonts.json`);
      if (!response.ok) throw new Error(`Font catalog HTTP ${response.status}`);
      const data = await response.json();
      if (!Array.isArray(data.fonts)) throw new Error('Invalid font catalog');

      for (const { family, files } of data.fonts) {
        for (const [style, file] of Object.entries(files || {})) {
          const normalizedStyle = style.toLowerCase();
          const face = new FontFace(family, `url("${FONT_BASE_URL}${file}")`, {
            weight: normalizedStyle.includes('bold') ? '700' : '400',
            style: normalizedStyle.includes('italic') ? 'italic' : 'normal'
          });
          await face.load();
          document.fonts.add(face);
        }
      }
      await document.fonts.ready;
      return [...new Set(data.fonts.map(font => font.family).filter(Boolean))];
    })();
  }
  return fontsPromise;
}
